import React from 'react'
import styled from 'styled-components'
import Card2 from './Card2'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';

const DetailCard = () => {
   return (
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
            <h3 className="small-heading">
              Building Tech. Building Community.
               </h3>
               <p className="c-para"> What Makes This Training Unique: It transforms technology development into a participatory process, where learners and communities co-create solutions rooted in justice, ethics and consultation. </p>
            </div>
            <div className='card-con'>
               <Card2
                  account={'Skills & Outcomes'}
                  text={'By the end of the course, participants will:'}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Understand the chains of activities in tech development and how to apply them responsibly.'}
                  text2={'Gain the ability to evaluate technologies critically for social, ethical, and environmental impact.'}
                  text3={'Build practical skills in ethical software design workflows and app development.'}
                  text4={'Strengthen their capacity to serve as facilitators of community-based tech development.'}
                  text5={'Develop a mindset that sees technology not just as tools, but as part of a larger process of individual and social transformation.'}
                  text6={'Science + Ethics: Participants learn to combine scientific rigor with ethical reflection, producing solutions that are fair, sustainable, and just.'}

               />
            </div>
         </InnerLayout>
      </PaymentStyled>
   )
}

const PaymentStyled = styled.section`
 .card-con {
    display: flex; /* Use flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding-top: 4rem; /* Adjust top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px; 
    margin: 0 auto;
    width: 100%; /* Ensure it takes full width of the container */
    
    /* Optional: If you want to increase the width of the cards themselves */
    .card2 {
      width: 100%; /* Adjust the width of individual cards */
      max-width: 100%; /* You can set a specific width like 80% or more */
    }

    @media screen and (max-width: 689px) {
      flex-direction: column; /* Stack content on mobile */
    }
  }

  p {
    text-align: center;
  }
`

export default DetailCard
